<template>
  <div style="background:#fff; width:100%; height:auto; position: relative;" >
    <div class="ibox-title">
      <h3>Select report from dropdown</h3>
    </div>
    <div class="col-lg-12 col-md-12">
      <div class="col-lg-4 col-md-4 m-t-sm">
        <v-select placeholder="Select report" :options="reports" label="label" v-model="selectedReport" @change="showReport">
        </v-select>
      </div>
    </div>
    <div style="margin-top: 60px;">
      <div v-if="report==='ClientOrderReports'"><ClientOrderReports/></div>
      <div v-else-if="report==='PaymentReports'"><PaymentReports /></div>
      <div v-else-if="report==='ProfitReports'"><ProfitReports /></div>
      <div v-else-if="report==='AdminOwerview'"><AdminOverview /></div>
    </div>
    <div style="clear:both; padding:20px"></div>
  </div>
</template>

<script>
import ClientOrderReports from './Reports/ClientOrderReports'
import PaymentReports from './Reports/PaymentReports.vue'
import ProfitReports from './Reports/ProfitReports.vue'
import AdminOverview from './Reports/AdminOverview.vue'
export default {
  data () {
    return {
      report: null,
      reports: [
        {label: 'Client Order Reports', value: 'ClientOrderReports'},
        {label: 'Payment Reports', value: 'PaymentReports'},
        {label: 'Profit Reports', value: 'ProfitReports'},
        {label: 'Admin Owerview', value: 'AdminOwerview'}
      ]
    }
  },
  components: {
    AdminOverview,
    ProfitReports,
    PaymentReports,
    ClientOrderReports
  },
  methods: {
    showReport (e) {
      this.report = e.value
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Reports.vue